import React, { useEffect, useRef } from "react";
import { Check, Minus } from "lucide-react";

/**
 * The task board's selection checkbox (Product Backlog cards, "select all",
 * carry-over list). A native checkbox kept for keyboard / screen readers, drawn
 * as a rounded accent box. `indeterminate` shows a dash (some selected).
 * Clicks do not bubble, so it can sit inside clickable cards.
 */
const SelectCheckbox = ({ checked, indeterminate = false, onChange, label, title, children, className = "" }) => {
  const input = useRef(null);
  useEffect(() => {
    if (input.current) input.current.indeterminate = indeterminate && !checked;
  }, [indeterminate, checked]);

  const filled = checked || indeterminate;
  return (
    <label
      title={title}
      onClick={(e) => e.stopPropagation()}
      className={`relative inline-flex items-center gap-1.5 cursor-pointer select-none ${className}`}
    >
      <input
        ref={input}
        type="checkbox"
        checked={Boolean(checked)}
        onChange={onChange}
        onKeyDown={(e) => e.stopPropagation()}
        aria-label={label}
        className="peer sr-only"
      />
      <span
        className={`w-[18px] h-[18px] shrink-0 rounded-[6px] border flex items-center justify-center text-white transition-colors peer-focus-visible:ring-2 peer-focus-visible:ring-accent-soft hover:border-accent ${
          filled ? "bg-accent border-accent" : "border-line2 bg-panel text-transparent"
        }`}
      >
        {indeterminate && !checked ? <Minus className="w-3 h-3" strokeWidth={3} /> : <Check className="w-3 h-3" strokeWidth={3} />}
      </span>
      {children}
    </label>
  );
};

export default SelectCheckbox;
